import { render, staticRenderFns } from "./ChroniclesPortrait.vue?vue&type=template&id=3af97a5c&scoped=true"
import script from "./ChroniclesPortrait.vue?vue&type=script&lang=js"
export * from "./ChroniclesPortrait.vue?vue&type=script&lang=js"
import style0 from "./ChroniclesPortrait.vue?vue&type=style&index=0&id=3af97a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af97a5c",
  null
  
)

export default component.exports